import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRouteAdmin = ({ children }) => {
  const state = useSelector((state) => state.authAdmin);
  if (state.loading) return null;

  if (!state.isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default PrivateRouteAdmin;
